import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useClipPathId } from "../hooks/use-clip-path-id";

export function EducateFilled(props) {
  const clipPathId = useClipPathId("educate-filled");
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M1.25217 6.44341L10.7478 3.10428C11.2696 2.89558 11.8957 2.89558 12.4174 3.10428L22.6435 6.44341C24.4174 6.96514 24.4174 8.94775 22.7478 9.57384L12.9391 13.1217C12.4174 13.3304 11.687 13.3304 11.1652 13.1217L1.25217 9.57384C-0.417391 8.94775 -0.417391 7.06949 1.25217 6.44341Z"
            fill="currentColor"
          />
          <path
            d="M5.21741 13.4348V18.0261C5.21741 18.1305 5.32175 18.3392 5.4261 18.4435C6.05219 18.8609 8.45219 20.4261 12 20.4261C15.6522 20.4261 17.7391 18.4435 18.2609 17.8174C18.3652 17.7131 18.3652 17.6087 18.3652 17.5044V13.4348C18.3652 13.1218 18.0522 12.9131 17.7391 13.0174C16.5913 13.5392 13.9826 14.5826 12 14.5826C10.1218 14.5826 7.09567 13.5392 5.84349 13.0174C5.53045 12.8087 5.21741 13.0174 5.21741 13.4348Z"
            fill="currentColor"
          />
          <path
            d="M21.4956 16.9824V11.3477L20.2435 11.9737V16.9824C19.4087 17.1911 18.7826 18.0259 18.7826 18.965C18.7826 20.1129 19.7217 20.9477 20.7652 20.9477C21.913 20.9477 22.7478 20.0085 22.7478 18.965C22.8522 18.0259 22.3304 17.2955 21.4956 16.9824Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect
              width={24}
              height="17.9478"
              fill="white"
              transform="translate(0 3)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
